


















































































































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import EyeIcon from 'mdi-vue/Eye';
import Modal from '@/components/Modal.vue';
import FormInput from '@/components/FormInput.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import api, { apiSandbox } from '@/libs/api';
import SingleDatePicker from '@/components/SingleDatePicker.vue';
import DateRangePicker from 'vue2-daterange-picker';
import CalendarIcon from '@/assets/calendar.svg';
import Loader from '@/components/Loader.vue';
import { User } from '@/libs/api.interfaces';
import { mapState } from 'vuex';
import { ValidationObserver } from 'vee-validate';
import moment from 'moment';

@Component({
  components: {
    LayoutContent,
    Button,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    ActionPopup,
    EyeIcon,
    Modal,
    FormInput,
    SearchField,
    SearchRow,
    Select,
    SingleDatePicker,
    DateRangePicker,
    CalendarIcon,
    Loader,
    ValidationObserver,
  },
  computed: mapState(['user']),
})
export default class Step5 extends Vue {
  @Prop(Function) onSetStep!: Function;
  activeTab = 0;
  sitTab = 0;
  idx = 0;
  loading = false;
  showModalResponse = false;
  showModalSit = false;
  initDate = {
    startDate: null,
    endDate: null,
  }

  get formatedReqAmount() {
    this.listTransaction.forEach((e: any) => {
      if (e.transactionNumber === this.transactionChange.transactionNumber) {
        this.transactionAmountReq = e.transactionAmount;
        this.transactionNumber = e.transactionNumber;
      }
    });
    return this.transactionAmountReq.toString();
  }

  get paymentFlagReturn() {
    // this.paymentFlagUrlList.forEach((e: any) => {
    //   if (e.type === this.channelIds.channel_id) {
    //     this.paymentFlagUrl = e.url;
    //   }
    // });
    if (this.channelIds.channel_id) {
      this.paymentFlagUrl = this.channelIds.detailMerchant.payment_url;
    }
    return this.paymentFlagUrl;
  }

  transactionAmountReq = 0

  loadingSitTest = true;

  serviceCode = '';
  // channelData sit
  sitBusinessName = '';
  channelIds: any = '';
  transactionChange: any = [];
  transactionNumber = '';
  showSitTest = '';
  activeButton = false;
  toggleEmail = false;
  paymentReffId = 'SANDBOX';
  flagType = '11';
  transactionMessage = 'Payment Flag Test';
  transactionStatus = '00-Approved';
  sitList = -1;
  showDetailId = 0;
  listTransaction: any = [];

  // reqParam sit
  channelIdsReq = '';
  currencyReq = 'IDR';
  insertId = '';
  additionalData = '';
  paymentFlagUrl = '';
  paymentFlagUrlList: any = [];
  transactionDate = {
    startDate: null,
    endDate: null,
  };
  // eslint-disable-next-line
  user!: {
    user: User;
  };

  channelIdList: any = [];

  loadingChannelId = false;

  listTab = [
    {
      tab: 'CREDIT CARD TESTING',
    },
    {
      tab: 'SCENARIO TESTING',
    },
    {
      tab: 'BEST PRACTICE TESTING',
    },
  ];

  listTestScenarioTest = [
    {
      testName: 'Invalid Channel ID',
      rc: '01',
      reqParam: `
      {
        "channelId": "SNBXSPR1",
        "currency": "IDR",
        "transactionNo": "630",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 12:01:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": "132",
        "customerAccount": "8164010000000630",
        "paymentReffId": "SANDBOX",
        "additionalData": null,
        "authCode": "f1fed4b0f0ce4a4b646c5bfdeae748e1b5e162acf146a1b37cdaef4c71a5778d"
      }`,
      res: `
      {
        "channelId": "SNBXSPR1",
        "currency": "IDR",
        "paymentStatus": "01",
        "paymentMessage": "Invalid channelId",
        "flagType": "11",
        "paymentReffId": "SANDBOX"
      }`,
    },
    {
      testName: 'Invalid Transaction No',
      rc: '01',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "transactionNo": "ABCD1234",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 12:01:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": "132",
        "customerAccount": "8164010000000630",
        "paymentReffId": "SANDBOX",
        "additionalData": null,
        "authCode": "0d03f24b16902ea46c9ecb0842686e8c5b90953320309efd936c1791fbea88e3"
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "paymentStatus": "01",
        "paymentMessage": "Invalid transactionNo",
        "flagType": "11",
        "paymentReffId": "SANDBOX"
      }`,
    },
    {
      testName: 'Invalid transactionAmount',
      rc: '01',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "transactionNo": "630",
        "transactionAmount": 105289,
        "transactionDate": "2017-10-25 12:01:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": "132",
        "customerAccount": "8164010000000630",
        "paymentReffId": "SANDBOX",
        "additionalData": null,
        "authCode": "55c4f2b2b1877802217760a85f28bdf426c5df5b20693af441a7aa5011adc9d8"
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "paymentStatus": "01",
        "paymentMessage": "Invalid Transaction Amount",
        "flagType": "11",
        "paymentReffId": "SANDBOX"
      }`,
    },
    {
      testName: 'Invalid insertId',
      rc: '01',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "transactionNo": "630",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 12:01:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": 190,
        "customerAccount": "8164010000000630",
        "paymentReffId": "SANDBOX",
        "additionalData": null,
        "authCode": "46a69b271253ee07f262b8b8b3c1f7d50a3c14d4e8f242163f6e1b099b00ddf3"
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "paymentStatus": "01",
        "paymentMessage": "Invalid insertId",
        "flagType": "11",
        "paymentReffId": "SANDBOX"
      }`,
    },
    {
      testName: 'Invalid authCode',
      rc: '01',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "transactionNo": "630",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 12:01:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": "132",
        "customerAccount": "8164010000000630",
        "paymentReffId": "SANDBOX",
        "additionalData": null,
        "authCode": "1cbc166406f16c6cf6d5b47b0b59314593c75f52d51212cf5a31fa61fba07xxx"
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "paymentStatus": "01",
        "paymentMessage": "Invalid AuthCode",
        "flagType": "11",
        "paymentReffId": "SANDBOX"
      }`,
    },
    {
      testName: 'Invalid Currency',
      rc: '01',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "USD",
        "transactionNo": "630",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 12:01:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": "132",
        "paymentReffId": "FSEHNU",
        "customerAccount": "8164010000000630",
        "authCode": "9328530de8b7e2655c0b0f068c5785d667fcec800d6357497791e6a7c1ba8c72",
        "additionalData": ""
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "USD",
        "paymentStatus": "01",
        "paymentMessage": "Invalid Currency",
        "flagType": "11",
        "paymentReffId": "FSEHNU"
      }`,
    },
    {
      testName: 'Invalid Transaction Status',
      rc: '01',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "transactionNo": "630",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 12:01:23",
        "transactionStatus": "01",
        "transactionMessage": "Invalid Transaction Status",
        "flagType": "11",
        "insertId": "132",
        "paymentReffId": "AEEB5KDF",
        "customerAccount": "8164010000000630",
        "authCode": "3c8b9a4070a9c3cbb84fe3f68e3813c961c0afaef181869fa9a02a03a7930b3a",
        "additionalData": ""
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "paymentStatus": "01",
        "paymentMessage": "Invalid Transaction Status",
        "flagType": "11",
        "paymentReffId": "AEEB5KDF"
      }`,
    },
    {
      testName: 'Invalid Customer Account (For VirtualAccount)',
      rc: '01',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "transactionNo": "630",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 12:01:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": "132",
        "paymentReffId": "9C8KAH2NFS",
        "customerAccount": "8164010000077777",
        "authCode": "9328530de8b7e2655c0b0f068c5785d667fcec800d6357497791e6a7c1ba8c72",
        "additionalData": ""
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "paymentStatus": "01",
        "paymentMessage": "Invalid VA Number",
        "flagType": "11",
        "paymentReffId": "9C8KAH2NFS"
      }`,
    },
    {
      testName: 'Success Transaction',
      rc: '00',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "transactionNo": "630",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 12:01:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": "132",
        "customerAccount": "8164010000000630",
        "paymentReffId": "SANDBOX",
        "additionalData": null,
        "authCode": "9328530de8b7e2655c0b0f068c5785d667fcec800d6357497791e6a7c1ba8c72"
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "paymentStatus": "00",
        "paymentMessage": "Success",
        "flagType": "11",
        "paymentReffId": "SANDBOX"
      }`,
    },
    {
      testName: 'Double Payment',
      rc: '02',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "transactionNo": "630",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 12:01:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": "132",
        "customerAccount": "8164010000000630",
        "paymentReffId": "SANDBOX",
        "additionalData": null,
        "authCode": "9328530de8b7e2655c0b0f068c5785d667fcec800d6357497791e6a7c1ba8c72"
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "paymentStatus": "02",
        "paymentMessage": "Transaction has been paid",
        "flagType": "11",
        "paymentReffId": "SANDBOX"
      }`,
    },
    {
      testName: 'Cancel by admin (optional)',
      rc: '05',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "transactionNo": "631",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 13:40:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": "133",
        "paymentReffId": "110XN1",
        "customerAccount": "8164010000000631",
        "authCode": "4636413ae0ba16bdfb091eb581c8d3eec8b804c4211c7d0369a1fca52e746fbf",
        "additionalData": ""
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "paymentStatus": "05",
        "paymentMessage": "Transaction has been canceled",
        "flagType": "11",
        "paymentReffId": "110XN1"
      }`,
    },
    {
      testName: 'Expired (optional)',
      rc: '04',
      reqParam: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "transactionNo": "631",
        "transactionAmount": "10000",
        "transactionDate": "2017-10-25 13:40:23",
        "transactionStatus": "00",
        "transactionMessage": "Approved",
        "flagType": "11",
        "insertId": "133",
        "paymentReffId": "110XN1",
        "customerAccount": "8164010000000631",
        "authCode": "4636413ae0ba16bdfb091eb581c8d3eec8b804c4211c7d0369a1fca52e746fbf",
        "additionalData": ""
      }`,
      res: `
      {
        "channelId": "TESSPRINT01",
        "currency": "IDR",
        "paymentStatus": "04",
        "paymentMessage": "Transaction has been expired",
        "flagType": "11",
        "paymentReffId": "110XN1"
      }`,
    },
  ];

  listTestCC = [
    {
      ccType: 'Visa',
      cardNumber: '4434260000000008',
      expDate: '01/39',
      cvv: '100',
      otp: '',
      rc: '00 (Approved)',
    },
    {
      ccType: 'Visa',
      cardNumber: '4434260000000008',
      expDate: '02/23',
      cvv: '101',
      otp: '',
      rc: '01 (Declined)',
    },
    {
      ccType: 'Mastercard',
      cardNumber: '5577810000000004',
      expDate: '01/39',
      cvv: '100',
      otp: '',
      rc: '00 (Approved)',
    },
    {
      ccType: 'Mastercard',
      cardNumber: '5577810000000004',
      expDate: '05/22',
      cvv: '103',
      otp: '',
      rc: '01 (Declined)',
    },
    {
      ccType: 'BCA Card',
      cardNumber: '1889800000000171',
      expDate: '03/25',
      cvv: '101',
      otp: '123456',
      rc: '00 (Approved)',
    },
    {
      ccType: 'BCA Card',
      cardNumber: '1889800000000189',
      expDate: '03/25',
      cvv: '101',
      otp: '',
      rc: '01 (Declined)',
    },
  ];

  listSitTest: any = [];
  loadingListTransaction = false;
  setDisplay = 'block';
  setShow = 'Show Detail';

  listCaseSit = [
    'Invalid Channel ID',
    'Invalid transactionNo',
    'Invalid transactionAmount',
    'Invalid insertId',
    'Invalid authCode',
    'Success Transaction',
    'Double payment',
  ];

  setSelectedTab(idx: any) {
    this.activeTab = idx;
  }

  setSitList(idx: number) {
    if (this.sitList === idx) {
      this.setDisplay = 'none';
      this.sitList = -1;
      this.setShow = 'Show Detail';
    } else {
      this.setDisplay = 'block';
      this.setShow = 'Hide Detail';
      this.sitList = idx;
    }
  }

  setSelectedTabSit(idx: any) {
    if (idx === 3) {
      this.sitTab = idx;
      this.listSitTest = [];
      this.getChannelIds();
      this.responseSitTest('step_1');
    }
  }

  setNext() {
    this.onSetStep(3);
  }

  showSampleResponse(idx: any) {
    setTimeout(() => {
      this.showModalResponse = true;
      this.showDetailId = idx;
    }, 100);
  }

  showSitProcess() {
    this.showModalSit = !this.showModalSit;
    this.getChannelIds();
  }

  mounted() {
    this.cekActive();
  }

  async responseSitTest(stepList: any) {
    // eslint-disable-next-line no-useless-catch
    try {
      const dateTime = moment(this.transactionDate.startDate).format('YYYY-MM-DD hh:mm:ss');
      this.loading = false;
      const { data, status } = await apiSandbox.post('/sit/test', {
        // eslint-disable-next-line @typescript-eslint/camelcase
        addtionalData: this.additionalData,
        channelId: this.channelIds.channel_id,
        paymentUrl: this.paymentFlagUrl,
        serviceCode: this.serviceCode,
        step: stepList,
        transactionAmount: this.transactionAmountReq,
        transactionDate: dateTime,
        transactionNo: this.transactionNumber,
      });
      if (status === 200) {
        if (data.data.next_step != null) {
          this.loadingSitTest = true;
          this.responseSitTest(data.data.next_step);
        } else {
          this.loadingSitTest = false;
        }
        this.listSitTest.push(data.data);
      }
    } catch (e) {
      throw e;
    }
  }

  async getChannelIds() {
    // eslint-disable-next-line no-useless-catch
    try {
      this.loadingChannelId = true;
      this.paymentFlagUrlList = [];
      this.channelIdList = [];
      const { data, status } = await apiSandbox.get('/merchant/channel/detail');
      this.loadingChannelId = false;

      if (status === 200) {
        this.sitBusinessName = data.merch_name;
        data.merchant_channel.forEach((val: any) => {
          this.channelIdList = this.channelIdList.concat(val.channels);
        });
        this.channelIdList.forEach((e: any) => {
          let urlFlag = e.detailMerchant.payment_url;
          if (e.service_code === '1083') {
            urlFlag = e.detailMerchant.detail_merchant_bw_core.url_payment_flag;
          }
          this.paymentFlagUrlList.push({
            type: e.channel_id,
            url: urlFlag,
            serviceName: e.service_name,
            channelName: e.channel_name,
            detailMerchant: e.detailMerchant,
          });

          this.serviceCode = e.service_code;
          // this.channelIdList.push(e.channel_id);
        });
      }
    } catch (e) {
      throw e;
    }
  }

  async cekActive() {
    // eslint-disable-next-line no-useless-catch
    try {
      const { data, status } = await apiSandbox.get('paymentChannel');
      if (status === 200) {
        data.forEach((e: any) => {
          if (e === '2002') {
            this.activeButton = true;
          }
        });
      }
    } catch (e) {
      throw e;
    }
  }

  async transactionList() {
    // eslint-disable-next-line no-useless-catch
    try {
      this.listTransaction = [];
      this.loadingChannelId = false;
      this.transactionChange = [];
      this.loadingListTransaction = true;
      const channelId = this.channelIds.channel_id;
      let channel = '';
      let credentials = '';

      this.paymentFlagUrlList.forEach((e: any) => {
        if (channelId === e.type) {
          channel = e.serviceName;

          if (e.channelName === 'BCA Virtual Account') {
            credentials = e.detailMerchant.comp_code;
          } else if (channel === 'BCA Klikpay') {
            credentials = e.detailMerchant.klikPayCode;
          } else {
            credentials = e.detailMerchant.channel_id;
          }
        }
      });
      const time = new Date();
      const timeNew = moment(time).format('YYYY-MM-DD+23:59:59');
      const timeOld = time.setTime(time.getTime() - (30 * 24 * 60 * 60 * 1000));
      const timeOldNew = moment(timeOld).format('YYYY-MM-DD+00:00:00');
      // eslint-disable-next-line max-len
      const { data, status } = await api.get(`transaction?channel=${channel}&paymentStartDate=${timeOldNew}&paymentEndDate=${timeNew}`);
      // eslint-disable-next-line no-useless-catch
      this.loadingListTransaction = false;
      // eslint-disable-next-line no-empty
      if (status === 200) {
        data.data.forEach((e: any) => {
          this.listTransaction.push({
            id: e.id,
            transactionNumber: e.transactionNo,
            transactionAmount: e.amount,
          });
        });
      }
    } catch (e) {
      throw e;
    }
  }
}
